module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_7.32819640.png";